import { Component, input } from '@angular/core';
import { AppRoutingModule } from "src/app/app.routing";

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [AppRoutingModule],
  templateUrl: './field-error.component.html',
  styleUrl: './field-error.component.scss',
})
export class FieldErrorComponent {
  public id = input<string>('');
}
